var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "popup-form"
  }, [_c('div', {
    staticClass: "content-form-popup"
  }, [_c('div', {
    staticClass: "header-text"
  }, [_c('div', {
    staticClass: "back-button-wrapper pointer",
    on: {
      "click": _vm.closePopup
    }
  }, [_c('img', {
    staticClass: "nav-link-icon filter-primary",
    attrs: {
      "src": require("@/images/modal-close.svg"),
      "alt": ""
    }
  })]), _c('div', {
    staticClass: "blackcolor pop-800"
  }, [_vm._v("Odovzdanie žiadosti")]), _c('button', {
    staticClass: "w-button saveformBtn",
    on: {
      "click": _vm.saveStatus
    }
  }, [_vm._v("Uložiť")])]), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(0), _c('input', {
    staticClass: "text-input w-input date-input",
    attrs: {
      "name": "dateOfUpload",
      "type": "date",
      "max": _vm.todayLong,
      "maxlength": "256"
    }
  })])])]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('label', {
    staticClass: "field-label"
  }, [_vm._v("Kedy ste žiadosť odovzdali"), _c('strong')]);

}]

export { render, staticRenderFns }